import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVS } from '@/shared/consts';

import { publicBaseQueryWithReauth } from '../queries/publicBaseQueryWithReauth';

export const publicService = createApi({
  reducerPath: 'publicApi',
  tagTypes: [],
  baseQuery: publicBaseQueryWithReauth({
    baseUrl: ENVS.PUBLIC_API_BASEURL,
  }),
  endpoints: () => ({}),
});
